import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.css";
const LoaderSimple = ({fontSize = 32, color="#0090d1", message, style}) => {
  return (
    <div
      style={{
        ...style,
        fontSize: fontSize,
        color: color
      }}
      className="ts-dbx-LoaderSimple"
      key={Math.random()}
    >
      <FontAwesomeIcon
        style={{
          fontSize: fontSize,
          color: color
        }}
        icon={["far", "circle-notch"]}
        spin
      />
      {message && <span>{message}</span>}
    </div>
  );
};

LoaderSimple.propTypes = {
  fontSize: PropTypes.number,
  color: PropTypes.string,
  message: PropTypes.string
};

export default LoaderSimple;
